import {
  FETCH_ISSUES_START,
  FETCH_ISSUES_SUCCESS,
  FETCH_ISSUES_FAILED,
  CREATE_ISSUE_START,
  CREATE_ISSUE_SUCCESS,
  CREATE_ISSUE_FAILED,
  UPDATE_ISSUE_START,
  UPDATE_ISSUE_SUCCESS,
  UPDATE_ISSUE_FAILED,
  DELETE_ISSUE_START,
  DELETE_ISSUE_SUCCESS,
  DELETE_ISSUE_FAILED,
  CREATE_ISSUE_COMMENT_SUCCESS,
  CREATE_ISSUE_COMMENT_START,
  CREATE_ISSUE_COMMENT_FAILED,
} from '../actions/actionTypes';

const initialState = {
  records: [],
  fetching: false,
  creating: false,
  updating: false,
  deleting: false,
  commenting: false,
  errors: {
    fetching: null,
    creating: null,
    updating: null,
    deleting: null,
    commenting: null,
  },
};

const addIssue = (records, issue) => [...records, issue];

const updateIssue = (records, updated) => {
  return records.map(issue => {
    if (issue.issue_key === updated.issue_key) {
      return updated;
    }
    return issue;
  });
};

const deleteIssue = (records, deleted) =>
  records.filter(issue => issue.issue_key !== deleted.issue_key);

const issuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ISSUES_START:
      return {
        ...state,
        fetching: true,
        errors: {
          ...state.errors,
          fetching: null,
        },
      };
    case FETCH_ISSUES_SUCCESS:
      return {
        ...state,
        fetching: false,
        records: action.issues,
      };
    case FETCH_ISSUES_FAILED:
      return {
        ...state,
        fetching: false,
        errors: {
          ...state.errors,
          fetching: action.error,
        },
      };
    case CREATE_ISSUE_START:
      return {
        ...state,
        creating: true,
        errors: {
          ...state.errors,
          creating: null,
        },
      };
    case CREATE_ISSUE_SUCCESS:
      return {
        ...state,
        creating: false,
        records: addIssue(state.records, action.issue),
      };
    case CREATE_ISSUE_FAILED:
      return {
        ...state,
        creating: false,
        errors: {
          ...state.errors,
          creating: action.error,
        },
      };
    case UPDATE_ISSUE_START:
      return {
        ...state,
        updating: true,
        errors: {
          ...state.errors,
          updating: null,
        },
      };
    case UPDATE_ISSUE_SUCCESS:
      return {
        ...state,
        updating: false,
        records: updateIssue(state.records, action.issue),
      };
    case UPDATE_ISSUE_FAILED:
      return {
        ...state,
        updating: false,
        errors: {
          ...state.errors,
          updating: action.error,
        },
      };
    case DELETE_ISSUE_START:
      return {
        ...state,
        deleting: true,
        errors: {
          ...state.errors,
          deleting: null,
        },
      };
    case DELETE_ISSUE_SUCCESS:
      return {
        ...state,
        deleting: false,
        records: deleteIssue(state.records, action.issue),
      };
    case DELETE_ISSUE_FAILED:
      return {
        ...state,
        deleting: false,
        errors: {
          ...state.errors,
          deleting: action.error,
        },
      };
    case CREATE_ISSUE_COMMENT_START:
      return {
        ...state,
        commenting: true,
        errors: {
          ...state.errors,
          commenting: null,
        },
      };
    case CREATE_ISSUE_COMMENT_SUCCESS:
      return {
        ...state,
        commenting: false,
        records: updateIssue(state.records, action.issue),
      };
    case CREATE_ISSUE_COMMENT_FAILED:
      return {
        ...state,
        commenting: false,
        errors: {
          ...state.errors,
          commenting: action.error,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default issuesReducer;
